import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const PlusIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M12 4V20M20 12H4" stroke="currentColor"></path>
    </SvgIcon>
  )
}
